import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicBody from '../EpicBody/epic.body.vue';
import { CommonConfig } from '../../configs/config.common';
import EpicSignInBtn from '../EpicSignInButton/epic.signin.vue';

@Component({
    components: {
        EpicBody,
        EpicSignInBtn,
    }
})
export default class EpicNavbar extends Vue {
    public title: string = 'EpicNavbar';
    public configs = new CommonConfig();
    public activePath: string = '';
    public indexExpend: number = -1;
    public userDropdown = {
        show: false,
        value: '',
    };
    public subNavList = [];

    public navItems: any[] = [
        {
            name: 'Home',
            selected: false,
            link: '/',
            subnav: null,
            childrenUrl: []
        },
        {
            name: 'Buy',
            selected: false,
            link: null,
            subnav: [{
                name: 'Buyers Guide',
                link: '/buyer-guide'
            }, {
                name: 'RIFO APP',
                link: '/download-app'
            }],
            childrenUrl: []
        },
        {
            name: 'Sell',
            selected: false,
            link: null,
            subnav: [{
                name: 'Sellers Guide',
                link: '/seller-guide'
            }, {
                name: 'RIFO APP',
                link: '/download-app'
            }],
            childrenUrl: []
        },
        {
            name: 'Download',
            selected: false,
            link: '/download-app',
            subnav: null,
            childrenUrl: []
        },
        // {
        //     name: 'All Homes',
        //     selected: false,
        //     link: '/map',
        //     subnav: null,
        //     childrenUrl: []
        // },
        {
            name: 'News',
            selected: false,
            link: '/news-list/all',
            subnav: null,
            childrenUrl: ['/news-detail/', '/news-list/']
        },
        {
            name: 'About Us',
            selected: false,
            link: '/about-us',
            subnav: null,
            childrenUrl: []
        },
        {
            name: 'Contact Us',
            selected: false,
            link: '/contact-us',
            subnav: null,
            childrenUrl: []
        }

    ];

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    @Watch('$route.path', { immediate: true, deep: true })
    public onRouterChange(val: any, oldVal: any) {
        this.activePath = val;
        const navLinks = this.navItems.map(elm => {
            return elm.link;
        });
        const activeLinkInd = navLinks.indexOf(val);
        if (activeLinkInd !== -1) {
            this.$store.commit('epicNavTo', activeLinkInd);
            return;
        }
        for (let i = 0; i < this.navItems.length; i++) {
            const findMatch = this.navItems[i].childrenUrl.find( (
                v: string) => val.indexOf(v) !== -1
            );
            if (findMatch) {
                this.$store.commit('epicNavTo', i);
                return;
            }
        }
        for (let i = 0; i < this.navItems.length; i++) {
            if (this.navItems[i].subnav) {
                const sublinks = this.navItems[i].subnav.map( (v: any) => v.link);
                if (sublinks.indexOf(val) !== -1) {
                    this.$store.commit('epicNavTo', i);
                    return;
                }
            }

        }
        this.$store.commit('epicNavTo', 0);
    }

    public mounted() {
    }

    public getLogo() {
        return this.configs.epicLogo;
    }

    public handleNavSelected(id: number, href: string) {
        this.$router.push(href);
    }

    public handleNavExpend(id: number, e: Event) {
        if (this.indexExpend === id) {
            this.indexExpend = -1;
            (this.$parent.$parent as any).navClose();
            return;
        }
        this.subNavList = this.navItems[id].subnav;
        (this.$parent.$parent as any).navExpend();
        this.indexExpend = id;
    }
    public handleSignButton() {
        this.$store.commit('bgBlurToggleHome');
    }

    public async logout() {
        const _this: any = this;
        const browserStore = _this.$browserStore;
        browserStore.clearSession();
        this.$store.commit('logout');
    }

    public dropDownOutside(event: any) {
        this.userDropdown.show = false;
    }
}
